{
  "DATE_PICKER": {
    "PREVIOUS_PERIOD": "Previous period",
    "NEXT_PERIOD": "Next period",
    "WEEK_NUMBER": "Week #{weekNumber}",
    "APPLY_BUTTON": "Aplica",
    "CLEAR_BUTTON": "Neteja",
    "DATE_RANGE_INPUT": {
      "START": "Data d'inici",
      "END": "Data de finalització"
    },
    "DATE_RANGE_OPTIONS": {
      "TITLE": "RANG DE DATES",
      "LAST_7_DAYS": "Últims 7 dies",
      "LAST_30_DAYS": "Últims 30 dies",
      "LAST_3_MONTHS": "Últims tres mesos",
      "LAST_6_MONTHS": "Últims sis mesos",
      "LAST_YEAR": "Darrer any",
      "THIS_WEEK": "This week",
      "MONTH_TO_DATE": "This month",
      "CUSTOM_RANGE": "Interval de dates personalitzat"
    }
  }
}
